// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__31cxN","abort":"style_abort__1oyLx","submit":"style_submit__2r3fu"};